var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"welcome-page"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-content"},[_c('div',{staticClass:"welcome-title"},[_vm._v("欢迎您来到")]),_c('div',{staticClass:"welcome-subtitle"},[_vm._v("数智健康管理中心")]),_c('div',{staticClass:"welcome-tips"},[_vm._v("请点击屏幕开始")])])
}]

export { render, staticRenderFns }